import React, { useMemo } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { appTheme } from "../../../shared/theme";
import { useNavigate } from "react-router-dom";

export const HomeComponent = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const cards = useMemo(
    () => [
      {
        k: "about",
        title: "About",
        body: "Houses, retreats, office venues — ready when your team is.",
        to: "/about",
      },
      {
        k: "features",
        title: "Features",
        body: "Activities + add-ons that feel like a real perk.",
        to: "/product/features",
      },
      {
        k: "get in touch",
        title: "Get in Touch",
        body: "Want to know more?",
        to: "/#contact",
      },
    ],
    []
  );

  const handleCardClick = (idx) => {
    const to = cards[idx].to;

    if (to.includes("#")) {
      const [path, hash] = to.split("#");
      navigate(path || "/");

      window.setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);

      return;
    }

    navigate(to);
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  };

  return (
    <Box
      id="home"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { xs: "100dvh", md: "100dvh" },
        height: { xs: "100dvh", md: "100dvh" },
        overflow: "hidden",
        isolation: "isolate",
        backgroundColor: "transparent",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={theme.mixins.toolbar} />

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: { xs: "auto", md: "visible" },
            display: "flex",
            alignItems: { xs: "flex-start", md: "center" },
          }}
        >
          <Grid container sx={{ width: "100%", m: 0 }}>
            <Grid item xs={12} md={7} lg={6} sx={{ minWidth: 0 }}>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", md: 640 },
                  pt: { xs: "30px", sm: 4, md: 0 },
                }}
              >
                {/* <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    width: "fit-content",
                    px: 1.6,
                    py: 0.9,
                    borderRadius: 999,
                    border: "1px solid rgba(255,255,255,0.18)",
                    backgroundColor: "rgba(255,255,255,0.10)",
                    backdropFilter: "blur(10px)",
                    color: "rgba(255,255,255,0.92)",
                    fontWeight: 900,
                    letterSpacing: ".14rem",
                    textTransform: "uppercase",
                    fontSize: 10,
                  }}
                >
                  New UI
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: 999,
                      backgroundColor: appTheme.palette.yellow.main,
                      boxShadow: "0 0 0 4px rgba(244,180,79,0.18)",
                    }}
                  />
                  Same Mission. Better Experience.
                </Box> */}

                <Box
                  sx={{
                    mt: { xs: 8, md: 2.2 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.1,
                    alignItems: { xs: "center", md: "flex-start" },
                  }}
                >
                  <Typography
                    component="div"
                    sx={{
                      fontWeight: 900,
                      lineHeight: 1.02,
                      fontSize: { xs: 50, sm: 54, md: 72 },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        backgroundColor: appTheme.palette.white.main,
                        px: { xs: 2.5, md: 2.1 },
                        py: { xs: 1.05, md: 1.2 },
                        borderRadius: { xs: 2.6, md: 3 },
                        color: appTheme.palette.blue.main,
                        boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
                      }}
                    >
                      Making it Work,
                    </Box>
                  </Typography>

                  <Typography
                    component="div"
                    sx={{
                      fontWeight: 900,
                      lineHeight: 1.02,
                      fontSize: { xs: 42, sm: 54, md: 72 },
                      textAlign: { xs: "center", md: "left" },
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        backgroundColor: appTheme.palette.white.main,
                        px: { xs:2.5, md: 2.1 },
                        py: { xs: 1.05, md: 1.2 },
                        borderRadius: { xs: 2.6, md: 3 },
                        color: appTheme.palette.blue.main,
                        boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
                      }}
                    >
                      Making it Fun
                    </Box>
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: { xs: 2, md: 4 },
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  <Typography
                    sx={{
                      color: appTheme.palette.white.main,
                      fontSize: { xs: 20, sm: 22, md: 28 },
                      fontWeight: 800,
                      lineHeight: 1.2,
                    }}
                  >
                    Flexible spaces. 
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.92)",
                      fontSize: { xs: 20, sm: 22, md: 28 },
                      fontWeight: 800,
                      lineHeight: 1.2,
                      mt: 0.6,
                    }}
                  >
                    Memorable experiences.
                  </Typography>

                  <Typography
                    sx={{
                      mt: { xs: 2.2, md: 1.6 },
                      color: "rgba(255,255,255,0.84)",
                      fontSize: { xs: 15, sm: 14.5, md: 16 },
                      lineHeight: 1.75,
                      maxWidth: { xs: "70%", sm: 520 },
                      mx: { xs: "auto", md: 0 },
                    }}
                  >
                    One platform to plan offsites, retreats, venues, and
                    experiences—built for teams, but fun enough for anything
                    else.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    mt: { xs: 2.3, md: 3.2 },
                    display: { xs: "none", md: "block" },
                  }}
                >
                  <Button
                    onClick={() => {
                      navigate("/about");
                      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
                    }}
                    sx={{
                      px: 2.8,
                      py: 1.25,
                      borderRadius: 3,
                      backgroundColor: appTheme.palette.yellow?.main,
                      color: appTheme.palette.white?.main,
                      fontWeight: 900,
                      letterSpacing: ".10rem",
                      textTransform: "uppercase",
                      "&:hover": {
                        opacity: 0.9,
                        backgroundColor: appTheme.palette.white?.main,
                        color: appTheme.palette.blue?.main,
                      },
                    }}
                  >
                    Discover
                  </Button>
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={5}
              lg={6}
              sx={{ display: { xs: "none", md: "block" } }}
            />
          </Grid>
        </Box>

        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
            gap: 1,
            flexShrink: 0,
            px: 2,
            pt: 1,
            pb: 0,
            mb: "50px",
          }}
        >
          {cards.map((c, idx) => (
            <Box
              key={c.k}
              role="link"
              tabIndex={0}
              onClick={() => handleCardClick(idx)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleCardClick(idx);
              }}
              sx={{
                width: "100%",
                boxSizing: "border-box",
                borderRadius: 3.2,
                px: 1.4,
                py: 1.5,
                cursor: "pointer",
                userSelect: "none",
                border: "1px solid rgba(255,255,255,0.18)",
                backgroundColor: "rgba(255,255,255,0.10)",
                backdropFilter: "blur(12px)",
                outline: "none",
                "&:active": {
                  backgroundColor: "rgba(255,255,255,0.16)",
                },
              }}
            >
              <Typography
                sx={{
                  color: appTheme.palette.white.main,
                  fontWeight: 950,
                  letterSpacing: ".08rem",
                  textTransform: "uppercase",
                  fontSize: 12,
                  mb: 0.7,
                }}
              >
                {c.title}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.86)",
                  lineHeight: 1.65,
                  fontSize: 13.5,
                  overflowWrap: "break-word",
                }}
              >
                {c.body}
              </Typography>
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexShrink: 0,
            px: 2,
            pt: 0,
            pb: "max(12px, env(safe-area-inset-bottom))",
            backgroundColor: "transparent",
          }}
        >
          <Button
            onClick={() => navigate("/about")}
            fullWidth
            sx={{
              py: 1.35,
              borderRadius: 3,
              backgroundColor: appTheme.palette.yellow.main,
              color: appTheme.palette.blue.main,
              fontWeight: 950,
              letterSpacing: ".12rem",
              textTransform: "uppercase",
              boxShadow: "none",
              "&:hover": {
                opacity: 0.92,
                backgroundColor: appTheme.palette.yellow.main,
              },
            }}
          >
            Discover
          </Button>
        </Box>
      </Container>
    </Box>
  );
};